module.exports = __webpack_public_path__ + "static/media/promptList.0b931ba6.svg";